import CalendarBody from "./CalendarBody/CalendarBody";
import CalendarWidget from "./CalendarWidget/CalendarWidget";

// Дни недели
export const DAY_NAMES = ['пн','вт','ср','чт','пт','сб','вс'];
/** Перечисление с месяцами */
export const MONTH_NAMES: any = [
	{
		id: 0,
		title: 'Январь'
	},
	{
		id: 1,
		title: 'Февраль'
	},
	{
		id: 2,
		title: 'Март'
	},
	{
		id: 3,
		title: 'Апрель'
	},
	{
		id: 4,
		title: 'Май'
	},
	{
		id: 5,
		title: 'Июнь'
	},
	{
		id: 6,
		title: 'Июль'
	},
	{
		id: 7,
		title: 'Август'
	},
	{
		id: 8,
		title: 'Сентябрь'
	},
	{
		id: 9,
		title: 'Октябрь'
	},
	{
		id: 10,
		title: 'Ноябрь'
	},
	{
		id: 11,
		title: 'Декабрь'
	}
];
// Минимальный год
export const OLD_YEAR = 1940;
// Максимальный год
export const MAX_YEAR = new Date().getFullYear() + 5;

export type BetweenChangeType = "none" | "changeForm" | "changeTo";

/** Тип выбора дат календаря */
export type SelectDateType = "once" | "between" | "list";

export { CalendarBody };

export default CalendarWidget;
